import { useNavigate } from 'react-router-dom'
import { useCallback } from 'react'
import useTerminal from '../models/useTerminal'

export default function useGraphRouter() {
  const navigate = useNavigate()
  const openSession = useTerminal(state => state.openSession)

  return useCallback(
    (node?: GraphNode) => {
      if (!node) return navigate('/')

      switch (node.type) {
        case 'node':
          return navigate(`/nodes/${node.modelNodeId}`)
        case 'network':
          // The "No network" hub is no network: its nodes are on the Nodes tab.
          return navigate(node.routeId ? `/networks/${node.routeId}` : '/nodes')
        case 'account':
          return navigate(`/account/${node.id}`)
        case 'service':
          if (node.link) window.open(`https://${node.link}`, '_blank', 'noopener,noreferrer')
          else openSession({ serviceName: node.routeId!, mode: 'modal' })
          return
        case 'location':
        default:
          return navigate('/')
      }
    },
    [navigate, openSession]
  )
}
